import React, { useEffect, useState , useRef} from "react";
import {
  Button,
  CircularProgress,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";

// import { DiscountDetails, eWayBillModalInitialState, EWayBillModalState, viewManageOrderRowsData } from "./ViewOrderType";
import dummyProductImage from "../../assets/image/png/dummyProduct.png";
import dummyOutlet from "../../assets/image/svg/dummyOutlet.svg";
import dummyOutlet2 from "../../assets/image/svg/dummyOutlet2.svg";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../manageBasket/ManageBasket.css";
import FormHeader from "../../components/dms_common/FormHeader";
import StarsRoundedIcon from "@mui/icons-material/StarsRounded";
import RadioButtonCheckedRoundedIcon from "@mui/icons-material/RadioButtonCheckedRounded";
import "./ViewOutletDetails.css";
import InfoDropDown from "../viewOrder/InfoDropDown";
import OutletDetailsData from "./components/OutletDetailsData";
import {
  additionalDetailsMetadata1,
  additionalDetailsMetadata2,
  financialDetailsMetaData1,
  financialDetailsMetaData2,
  outletDetailsMetaData1,
  outletDetailsMetaData2,
  outletDetailsMetaData3,
  shippingAndBillingDetailsMetaData1,
  shippingAndBillingDetailsMetaData2,
  shippingAndBillingDetailsMetaData3,
} from "./ViewOutletDetailsConfig";
import OutletCancelModal from "./components/OutletCancelModal";
import CustomGenericModal from "../../components/dms_common/CustomGenericModal";
import { customStyle, GenericModal, getGenericModalProps, initialGenericModalProps } from "../viewOrder/ViewOrderUtils";
import { getApprovalRejectionRequestBody, getApprovalRequestId, getOutletAccountInfo, getOutletCreditInfo, getViewOutletData, UpdateOutletApprovalData } from "./ViewOutletDetailsUtils";
import { ViewOutletDetailsData } from "../../types/types";
import { Loader } from "../../components/loader/Loader";
import { getOutletApprovalData } from "../../services/manageOrderService";
import { getConfigData } from "../../services/configurationService";
import OutletLogoSvg from "./components/OutletLogoSvg";
import { getAccessToken } from "../../services/authenticationService";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const ViewOutletDetails = () => {
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const {currency} = ConfigDictionary;
  const designation = JSON.parse(localStorage.authContext).user.designation || [];
  const currentDesignation = designation.join(",")
  const accessToken = getAccessToken();

  const {outletId} = useParams();
  const [loader, setLoader] = useState(true);
  const [outletDetails, setOutletDetails] = useState<ViewOutletDetailsData | undefined>(undefined);
  const [outletApprovalData, setOutletApprovalData] = useState<any>()
  const [outletApprovalStatus, setOutletApprovalStatus] = useState<string>();
  const [error, setError] = useState<string | null>(null);
  const [outletStatusChangeLoading, setOutletStatusChangeLoading] =
    useState<string>("");
  const isPriceGroupRequired = useRef<boolean>(true);
  const isCompanyPortal = useRef<boolean>(false);

  const [orderCancelModalOpen, setOrderCancelModalOpen] =
    useState<boolean>(false);
  const [selectedRejectionReason, setSelectedRejectionReason] =
    useState<string>(``);
  const [showFullImage, setShowFullImage] = useState(false);
  const [rejectionReasonString, setRejectionReasonString] =
    useState<string>("");
  // const[rejectionReason, setRejectionReason] = useState<string>("")
  const approvalRequestId = useRef<string>("");
  const [outletStatusChanged, setOutletStatusChanged] = useState<string>("");
  const [companyPortalLoginId, setCompanyPortalLoginId] = useState<String>("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [genericModalProps, setGenericModalProps] = useState<GenericModal>(initialGenericModalProps);
  const [downloadingImage, setDownloadingImage] = useState<boolean>(false);
  const resetRejectOrderState = () => {
    setOrderCancelModalOpen(false);
    setSelectedRejectionReason("");
    setRejectionReasonString("");
  };
  const outletLocationTransformerName = useRef<string>("outlet_location_transformer");

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
  }));

  const handleReasonStringChange = (reason: string) => {
    setRejectionReasonString(reason);
  };

  const getOutletDetails = async () => {
  setLoader(true);
  setError(null);

  try {
    const response = await getViewOutletData(outletId ?? "", outletLocationTransformerName.current);

    let bank = "", ifsc = "", outletPan = "", outletGstin = "", shiptoGSTIN = "";
    let creditLimit = "", creditDays = "";

    if (response?.data?.features?.length > 0) {
      const data = response.data.features[0];

      const {
        activeStatus,
        outletName,
        outletCode,
        channel: outletChannel,
        outletClass,
        address: outletAddress,
        location = {},
        contactno: outletContact,
        email: outletEmail,
        extendedAttributes = {},
        immediateParent,
        latitude: outletLatitude,
        longitude: outletLongitude,
        creationTime: outletCreateDate,
        account: outletAccountNo,
        outletType,
        subChannel: outletSubChannel,
        priceListId: outletPriceGroup,
        outletCategory,
        beat: outletRoute,
        blobKey: imageUrl,
      } = data;
      const {
        city: outletCity,
        pincode: outletPincode,
      } = location;

      const {
        preferredPaymentMode: paymentMode,
        discountPercentage,
        cashDiscount,
        loyaltybalance: loyaltyBalance,
        walletbalance: walletBalance,
        shipTo = {},
        keyAccount,
        salesrep: salesRepCode,
        salesRepName,
        supplierName,
      } = extendedAttributes;

      const distributorCode = extendedAttributes["parent-1-0-id"] ?? extendedAttributes["parent-0-1-id"] ?? extendedAttributes["distributor"] ?? "";

      const {
        city: shipToCity,
        state: shipToState,
        address: shipToAddress,
        pincode: shipToPincode,
        contactNo: shipToContact,
        contactName: shipToContactPersonName,
        description: shipToDescription,
      } = shipTo;

      const [res1] = await Promise.all([
        getOutletCreditInfo(outletCode ?? ""),
      ]);
     

      if (res1?.data?.features?.length > 0) {
        const data2 = res1.data.features[0];
        ({
          creditLimit = "",
          totalDueDays: creditDays = "",
        } = data2);
      }

      setOutletDetails({
        keyAccount,
        activeStatus,
        outletName,
        outletCode,
        outletChannel,
        outletClass,
        outletAddress,
        outletCity,
        outletPincode,
        outletContact,
        outletEmail,
        distributorCode,
        paymentMode,
        discountPercentage: discountPercentage ? `${discountPercentage}%` : "",
        cashDiscount: cashDiscount ? `${cashDiscount}` : "",
        loyaltyBalance,
        walletBalance,
        salesRepCode,
        outletLatitude,
        outletLongitude,
        outletCreateDate,
        outletAccountNo,
        outletType,
        outletSubChannel,
        outletPriceGroup,
        shipToCity,
        shipToState,
        shipToAddress,
        shipToPincode,
        shipToContact,
        shipToContactPersonName,
        shipToDescription,
        creditLimit,
        creditDays,
        bank,
        ifsc,
        outletGstin,
        outletPan,
        shiptoGSTIN,
        outletCategory,
        outletRoute,
        salesRepName,
        supplierName,
        imageUrl,
      });

    } else {
      setOutletDetails(undefined);
      console.warn("No data found for this outlet.");
    }
  } catch (err) {
    setError("Failed to fetch outlet details.");
    console.error(err);
  } finally {
    setLoader(false);
  }
};


  const fetchOutletApprovalData = async () => {
    try {
      const outletData = await getOutletApprovalData(outletId ?? "") ?? {};
      const feature = outletData?.data?.features?.[0] ?? {};
      setOutletApprovalData(feature);

      setOutletApprovalStatus(feature?.status?.toUpperCase());
  
    } catch (error) {
      console.error("Failed to fetch outlet approval data:", error);
    }
  };

  const fetchRequiredConfigs = async () => {
    try {
      const companyPortalLoginIdConfig = await getConfigData(
        "dms_configuration",
        "companyPortalLoginId"
      );
      const outletLocationTransformerConfig = await getConfigData(
        "dms_configuration",
        "outletLocationTransformerName"
      );
      const res = await getConfigData("dms_configuration", "isPriceGroupRequired");
      isPriceGroupRequired.current = res[0]?.configValue ?? true
      setCompanyPortalLoginId(companyPortalLoginIdConfig[0]?.configValue ?? "reportadmin")
      isCompanyPortal.current = designation.includes(companyPortalLoginIdConfig[0]?.configValue ?? "reportadmin")
      outletLocationTransformerName.current = outletLocationTransformerConfig[0]?.configValue ?? "outlet_location_transformer";
    } catch (e) {
      console.error("Error while fetching configs", e);
      setGenericModalProps(
        getGenericModalProps("error", "Error while fetching configs")
      );
    }
  };

  const fetchApprovalRequestId = async () => {
    try{
      const response = await getApprovalRequestId(outletId ?? "");
      approvalRequestId.current = response?.data?.features[0]?.requestId;
    }catch(e){
      console.error("Error fetching approval request Id");
      setGenericModalProps(getGenericModalProps("error", "Error fetching approval request Id"))
    }
  }

  const refresh = async () => {
    
    setLoader(true);
      try {
        await Promise.all([
          fetchOutletApprovalData(),
          getOutletDetails()
        ]);
      } catch (error) {
        console.error("Error while fetching data:", error);
      } finally{
        setLoader(false);
      }
  };

  useEffect(() => {
    const fetchAllInitialData = async () => {
      try {
        await Promise.all([
          fetchRequiredConfigs(),
          fetchOutletApprovalData()
        ]);
        
        if (isCompanyPortal.current) await fetchApprovalRequestId();
        await getOutletDetails();
      } catch (error) {
        console.error("Error while fetching data:", error);
      }
    };

    fetchAllInitialData();
  }, [outletId, outletStatusChanged]);

  const resetGenericModalProps = () => setGenericModalProps(initialGenericModalProps);

  
  const approveOutlet = async () => {
    const requestBody = getApprovalRejectionRequestBody(outletId ?? "", currentDesignation, "APPROVED")
    const response = await UpdateOutletApprovalData(requestBody, approvalRequestId.current);
    const status = response?.data?.features?.[0]?.status;
    setOutletStatusChanged(status);
    await refresh();
  }

  const rejectOutlet = async () => {
    const requestBody = getApprovalRejectionRequestBody(outletId ?? "", currentDesignation, "REJECTED",selectedRejectionReason)
    const response = await UpdateOutletApprovalData(requestBody, approvalRequestId.current);
    const status = response?.data?.features?.[0]?.status;
    setOutletStatusChanged(status);
    await refresh();
  }

  const handleApproveClick = async () => {
    const message = `Are you sure you want to approve this outlet?`;

    const updatedGenericModalProps = getGenericModalProps(
      "positive",
      message,
      "Yes",
      "No",
      async () => {
        await handleApprove();
        await refresh();
      },
      resetGenericModalProps
    );

    setGenericModalProps(updatedGenericModalProps);
  }

  const handleApprove = async () => {
    try {
      setOutletStatusChangeLoading("APPROVED")
      await approveOutlet();
      const message = `${outletDetails?.outletName} has been approved and added successfully.`;

      const updatedGenericModalProps = getGenericModalProps(
        "success",
        message,
        "Continue",
        "",
        resetGenericModalProps
      );

      setGenericModalProps(updatedGenericModalProps);
      setOutletStatusChangeLoading("");
      

    } catch (error) {
      console.error("Approval failed:", error);

      const errorMessage = `${outletDetails?.outletName ?? "Outlet"} approval failed. Please try again.`;

      const updatedGenericModalProps = getGenericModalProps(
        "error",
        errorMessage,
        "Close",
        "",
        resetGenericModalProps
      );

      setGenericModalProps(updatedGenericModalProps);
      setOutletStatusChangeLoading("");
    } finally {
      await refresh();
    }
  };

  const handleRejectClick = async () => {
    try {
      resetRejectOrderState()
      setOutletStatusChangeLoading("REJECTED")
      await rejectOutlet();
      const message = `${outletDetails?.outletName} has been rejected successfully.`;

      const updatedGenericModalProps = getGenericModalProps(
        "success",
        message,
        "Continue",
        "",
        resetGenericModalProps
      );

      setGenericModalProps(updatedGenericModalProps);
      setOutletStatusChangeLoading("");
    } catch (error) {
      console.error("Rejection failed:", error);

      const errorMessage = `${outletDetails?.outletName ?? "Outlet"} rejection failed. Please try again.`;

      const updatedGenericModalProps = getGenericModalProps(
        "error",
        errorMessage,
        "Close",
        "",
        resetGenericModalProps
      );

      setGenericModalProps(updatedGenericModalProps);
      setOutletStatusChangeLoading("");
    } finally {
      await refresh();
    }
  };

  const handleDownloadImageClick = async () => {
    setDownloadingImage(true);
    try {
      const url = outletDetails?.imageUrl + `?access_token=${accessToken}`;

      const outletImageDownloadLink = document.createElement('a');
      outletImageDownloadLink.href = url;
      outletImageDownloadLink.download = 'image.jpg';
      document.body.appendChild(outletImageDownloadLink);
      outletImageDownloadLink.click();
      document.body.removeChild(outletImageDownloadLink);

    } catch (error: any) {
      setGenericModalProps(
        getGenericModalProps("error", "Error in downloading Outlet Image")
      );
    }finally{
      setDownloadingImage(false);
    }
  }

  const handleImageClick = () => {
    if (outletDetails?.imageUrl) {
      setShowFullImage(true);
    }
  };

  const closeImage = () => {
    setShowFullImage(false);
  };

  const buttonLoading = (orderStatusChangeLoading: string, id: string): boolean => {
    if (orderStatusChangeLoading === id) return true;
    else return false;
  };
  

  const labelMap = {
    active: {
      labelText: "Active",
      color: "#14AD00",
      bgColor: "#F2FFF8",
      logoColor: "#118402"
    },
    inactive: {
      labelText: "Inactive",
      color: "#D93D3E",
      bgColor: "#FFF9F8",
      logoColor: "#B50202"
    },
  } as const;

  const rowMetadata = {
    outletDetails: "Outlet Details",
    financialDetails: "Financial Details",
    shippingAndBillingDetails: "Shipping & Billing Details",
    additionalDetails: "Additional Details",
  };

  const getMetaDataList = (rowKey: string) => {
    switch (rowKey) {
      case "outletDetails":
        return [
          outletDetailsMetaData1,
          outletDetailsMetaData2,
          outletDetailsMetaData3,
        ];

      case "financialDetails":
        return [financialDetailsMetaData1, financialDetailsMetaData2];

      case "shippingAndBillingDetails":
        return [
          shippingAndBillingDetailsMetaData1,
          shippingAndBillingDetailsMetaData2,
          // shippingAndBillingDetailsMetaData3,
        ];

      case "additionalDetails":
        return [additionalDetailsMetadata1, additionalDetailsMetadata2(!isPriceGroupRequired.current)];

      default:
        return [];
    }
  };

  const activeStatus = outletDetails?.activeStatus;
  // const activeStatus = "active";
  const config =
    labelMap[activeStatus as keyof typeof labelMap] ?? labelMap.active;

  const isKeyAccount = outletDetails?.keyAccount === 'true';

  if (loader) {
    return <Loader />;
  }

  const rejectionReasonsArray = [
    "Incomplete Documentation",
    "Duplicate Outlet Entry",
    "Incorrect Outlet Details",
    "Non-Serviceable Area"
  ]
   const handleReasonChange = (reason: string) => {
    setSelectedRejectionReason(reason);
  };
  const isUserAllowedToApprove = designation.includes(companyPortalLoginId) 
    && outletApprovalStatus === "PENDING";

  return (
    <>
      <div
        className="view_outlet_details_parent_vo"
        style={{ width: "100%" }}
      >
        <CustomGenericModal
          type={genericModalProps?.type}
          message={genericModalProps?.message}
          leftButtonText={genericModalProps?.leftButtonText}
          rightButtonText={genericModalProps?.rightButtonText}
          modalOpen={genericModalProps?.open}
          onLeftButtonClick={genericModalProps?.onLeftButtonClick}
          onRightButtonClick={genericModalProps?.onRightButtonClick}
          leftButtonPadding={genericModalProps?.leftButtonPadding}
          onClose={resetGenericModalProps}
          loading={Boolean(outletStatusChangeLoading?.length)}
          width={genericModalProps?.width}
        />
        {/* <ScreenOverlay apply={showOverlay} /> */}
        <div className="view_outlet_details_header_with_search">
          <div className="view_outlet_header">
            <FormHeader
              parentLabel={"New Outlet Approval Status"}
              label={"View Outlet"}
              goBackToParent={() =>
                navigate(
                  `/dashboard/sale/manageOutletApproval` 
                )
              }
            />
          </div>
        </div>

        <div className="outlet_details_container">
          <div className="outlet_details_container_header">
            <div className="outlet_details_container_heading">
              Outlet Code {outletDetails?.outletCode}
            </div>
            <InfoDropDown
              approvalStatus={outletApprovalData?.status?.toUpperCase()}
              approvedDate={outletApprovalData?.lastModifiedTime}
              approvedBy={outletApprovalData?.currentApproverId}
              approvalReason={outletApprovalData?.remarks}
            ></InfoDropDown>
          </div>

          <div className="outlet_details_container_info" >
            <div className="outlet_card_container">
              <div className="outlet_card">
                {/* <div
                  className="outlet_logo_container"
                  style={{
                    borderRadius: "50%",
                    border: `1px solid ${config.color}`,
                    cursor: "pointer",
                  }}
                  onClick={handleImageClick}
                >
                  {outletDetails?.imageUrl ? (
                    <img
                      src={outletDetails?.imageUrl ?? ""}
                      alt="Outlet"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <OutletLogoSvg color={config.logoColor} />
                  )}

                  <div
                    className="outlet_logo_label"
                    style={{
                      color: `${config.color}`,
                      background: `${config.bgColor}`,
                      border: `0.5px solid ${config.color}`,
                    }}
                  >
                    <RadioButtonCheckedRoundedIcon
                      sx={{ width: "10px", height: "10px" }}
                    />
                    <span style={{ fontSize: "11px", fontWeight: 600 }}>
                      {config.labelText}
                    </span>
                  </div>
                </div>

                {showFullImage && (
                  <div className="image_modal_overlay" onClick={closeImage}> <img
                      src={outletDetails?.imageUrl ?? ""}
                      alt="Full Outlet"
                      className="image_modal_content"
                    />
                  </div>
                )} */}
                          

                <span className="outlet_name">{outletDetails?.outletName}</span>
                <span className="outlet_code">{outletDetails?.outletCode}</span>
                {isKeyAccount && (
                  <div className="key_account_container">
                    <StarsRoundedIcon
                      sx={{
                        color: "#FDB42C",
                        background: "#FFE8BF",
                        height: "15px",
                        width: "15px",
                        borderRadius: "50%",
                      }}
                    />
                    <span
                      style={{
                        color: "#454545",
                        fontSize: "13px",
                        fontWeight: 500,
                      }}
                    >
                      Key Account
                    </span>
                  </div>
                )}
                {outletDetails?.imageUrl && (
                  <span
                    className={`outlet-image-download ${downloadingImage ? 'disabled' : ''}`}
                    onClick={!downloadingImage ? handleDownloadImageClick : undefined}
                    style={{ pointerEvents: downloadingImage ? 'none' : 'auto', cursor: downloadingImage ? "not-allowed" : "pointer" }}
                  >
                    Download Outlet Image
                  </span>
                )}
              </div>
            </div>
            <SimpleBar className="outlet_info_container">
              <div className="outlet_info">
                {Object.entries(rowMetadata).map(([key, value]) => {
                  const metadataList = getMetaDataList(key);
                  return (
                    <OutletDetailsData
                      outletData={outletDetails}
                      key={key}
                      heading={value}
                      outletDetails={metadataList}
                    />
                  );
                })}
              </div>
            </SimpleBar>
          </div>

          {isUserAllowedToApprove && <div className="outlet_details_container_footer">
            <div className="outlet_approval_action_buttons_wrapper">
              <Button
                className="outlet_approval_action_button"
                key={"REJECTED"}
                hidden={!isUserAllowedToApprove}
                disabled={buttonLoading(outletStatusChangeLoading,"REJECTED")}
                sx={{
                  minWidth: "100px",
                  color: `#ffffff !important`,
                  fontWeight: 500,
                  fontSize: `12px !important`,
                  backgroundColor: `#C44C36 !important`,
                  border: `1px solid #C44C36 !important`,
                  cursor: "pointer",
                  letterSpacing: "0.0001rem",
                  paddingLeft: "12px",
                  margin: "10px",
                  borderRadius: "8px 8px 8px 8px",
                  "&:hover": {
                    backgroundColor: `#C44C36 !important`,
                  },
                  textTransform: "none",
                  visibility: isUserAllowedToApprove ? "visible" : "hidden",
                }}
                onClick={() => setOrderCancelModalOpen(true)}
              >
                {buttonLoading(
                    outletStatusChangeLoading,
                    "REJECTED"
                  ) ? (
                    <CircularProgress
                      style={{
                        ...customStyle,
                        color: "#1D8DED",
                        height: 15,
                        width: 15,
                      }}
                    />
                  ) : (
                    "Reject"
                )}
              </Button>
              <Button
                className="outlet_approval_action_button"
                hidden={!isUserAllowedToApprove}
                disabled={buttonLoading(outletStatusChangeLoading,"APPROVED")}
                sx={{
                  minWidth: "100px",
                  color: `#ffffff !important`,
                  fontWeight: 500,
                  fontSize: `12px !important`,
                  backgroundColor: `#00C6B1 !important`,
                  border: `1px solid #00C6B1 !important`,
                  cursor: "pointer",
                  paddingLeft: "12px",
                  margin: "10px",
                  letterSpacing: "0.0001rem",
                  borderRadius: "8px 8px 8px 8px",
                  "&:hover": {
                    backgroundColor: `#00C6B1 !important`,
                  },
                  textTransform: "none",
                  visibility: isUserAllowedToApprove ? "visible" : "hidden",
                }}
                onClick={ async () => await handleApproveClick()}
              >
                {buttonLoading(
                    outletStatusChangeLoading,
                    "APPROVED"
                  ) ? (
                    <CircularProgress
                      style={{
                        ...customStyle,
                        color: "#1D8DED",
                        height: 15,
                        width: 15,
                      }}
                    />
                  ) : (
                    "Approve"
                  )}
              </Button>
            </div>
          </div>}
        </div>
        <OutletCancelModal
          headerText={"Outlet is being rejected"}
          modalOpen={orderCancelModalOpen}
          selectedRejectionReason={selectedRejectionReason}
          loading={
            buttonLoading(outletStatusChangeLoading, "REJECTED")
          }
          // loading={false}
          onClose={resetRejectOrderState}
          onButtonClick={async() => await handleRejectClick()}
          inputActive={true}
          inputString={rejectionReasonString}
          handleReasonStringChange={handleReasonStringChange}
          rejectionReasons={rejectionReasonsArray}
          handleReasonChange={handleReasonChange}
        />
      </div>
    </>
  );
};

export default ViewOutletDetails;
